// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectView_wrapper__236zn","modalOpen":"ProjectView_modalOpen__3mUBR","modalBoxProjectPeopleList":"ProjectView_modalBoxProjectPeopleList__XpQJM"};